import React, { createContext, useContext, useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

interface ContentContextData {
  /** Curso selecionado, vindo de `?courseid=`. */
  courseId: string;
  /** Troca o curso e grava na URL (persiste entre as abas). */
  setCourseId: (courseId: string) => void;
}

const ContentContext = createContext<ContentContextData>({
  courseId: '',
  setCourseId: () => undefined,
});

/**
 * Mantém o curso escolhido no Cadastro de Conteúdo. Fica na URL para que a
 * escolha valha em todas as abas e sobreviva a recarregar a página.
 */
export const ContentProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const history = useHistory();
  const location = useLocation();

  const courseId = useMemo(
    () => new URLSearchParams(location.search).get('courseid') ?? '',
    [location.search],
  );

  const setCourseId = useCallback(
    (nextCourseId: string) => {
      const params = new URLSearchParams(location.search);
      if (nextCourseId) params.set('courseid', nextCourseId);
      else params.delete('courseid');

      const qs = params.toString();
      history.replace({ pathname: location.pathname, search: qs ? `?${qs}` : '' });
    },
    [history, location.pathname, location.search],
  );

  return (
    <ContentContext.Provider value={{ courseId, setCourseId }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContentCourse = () => useContext(ContentContext);
